module.exports = __webpack_public_path__ + "static/röver-ede30a13f6667aebecb885a4b365e4ea.jpeg";